import cx from 'classnames'

import HoldingImage from './holding-image/holding-image'
import styles from './product-image.module.css'

interface Props {
  isAvailable?: boolean
  image?: string
  unavailableImageMessage: string
  unavailableVehicleMessage?: string
  alt: string
  isPending: boolean
  children?: React.ReactNode
}

interface UnavailableProps extends Props {
  isAvailable: false
  unavailableVehicleMessage: string
}

export const ProductImage: React.FC<Props | UnavailableProps> = ({
  isAvailable,
  image,
  alt,
  children,
}) => {
  const hasImage = image && image.length > 0

  return (
    <div className={styles.imgContainer}>
      {hasImage ? (
        <img
          className={cx(styles.img, { [styles.unavailable]: !isAvailable })}
          src={image}
          alt={alt}
        />
      ) : (
        <HoldingImage text="Image Unavailable" isAvailable={isAvailable} />
      )}
      {children}
    </div>
  )
}
